export function stringToURL(string) {
  return encodeURI(string.replace(/ /g, '-'));
}
